import React, { Fragment, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import moment from "moment";
import {
  setTableListData,
  setTableActionDetails,
} from "../../actions/tableListing/tableListDataAction";
import { buildLogisticTableActionDetails } from "../../helper/logisticTableAction";
import ShipmentProgressCell from "./ShipmentProgressCell";
import { SHIPMENT_PROGRESS_TAB } from "../../helper/shipmentProgress";

const LogisticCustomerDelivery = ({
  tabTableData,
  isLoading,
  OnhandleTableSortColumn,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isO2WPage =
    window.location.pathname.split("/")[1] === "dashboard" ? true : false;

  const tableSorting = useSelector(
    (state) => state.TableSortingData.tableListData
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (tabTableData.logisticsCustomerDeliveryPendingTab?.length > 0) {
      setTotalRecords(tabTableData.totalRecords);
      setPageNo(Number(tabTableData.currentPage));
      dispatch(
        setTableListData(tabTableData.logisticsCustomerDeliveryPendingTab)
      );
    } else {
      setTotalRecords(0);
      setPageNo(1);
    }
  }, [tabTableData.logisticsCustomerDeliveryPendingTab]);

  //// handle Table Asc Des sorting with pagination change
  const handleTableAscDes = (pagination, filters, sorter) => {
    const sortOrder = sorter.order;
    const sortField = sorter.field;
    OnhandleTableSortColumn({
      sortColumn: sortField,
      orderBy:
        sortOrder === "ascend"
          ? "asc"
          : sortOrder === "descend"
          ? "desc"
          : "asc",
      currentPage: pagination.current,
    });
  };
/// handle overview Details page code
  const handleOverviewDetailsPage = (rowData) => {
    dispatch(setTableActionDetails(buildLogisticTableActionDetails(rowData)));
    navigate(
      `/${
        isO2WPage ? "o2w" : "logistic"
      }/overviewDetails/Customer Delivery Pending/${encodeURIComponent(
        rowData.customer_PO_Number
      )}`
    );
  };

  const tableColumns = [
    {
      title: "Shipment Progress",
      dataIndex: "shipmentStatus",
      showSorterTooltip: false,
      width: 320,
      render: (_i, row) => (
        <ShipmentProgressCell
          row={row}
          tab={SHIPMENT_PROGRESS_TAB.CUSTOMER_DELIVERY_PENDING}
        />
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "customer_Organization_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 250,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_Organization_Name
              ? row.customer_Organization_Name
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Customer Number",
      dataIndex: "customer_Organization_Code",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Code"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_Organization_Code
              ? row.customer_Organization_Code
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Shipping Line Name",
      dataIndex: "portName",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "portName"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 220,
      render: (_i, row) => {
        return (
          <div>
            {row.portName
              ? row.portName
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimated Delivery Date",
      dataIndex: "delivery_Date_Estimated",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "delivery_Date_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.delivery_Date_Estimated
              ? moment(row.delivery_Date_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Estimated time of Arrival",
      dataIndex: "estimated_Time_Of_Arrival",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "estimated_Time_Of_Arrival"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.estimated_Time_Of_Arrival
              ? moment(row.estimated_Time_Of_Arrival).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Actual Time of Arrival",
      dataIndex: "etA_Port_Actual",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "etA_Port_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.etA_Port_Actual
              ? moment(row.etA_Port_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Order Date",
      dataIndex: "customer_PO_Date",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Date"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.customer_PO_Date
              ? moment(row.customer_PO_Date).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "SAP Order Number",
      dataIndex: "sap_Order_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "sap_Order_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.sap_Order_Number
              ? row.sap_Order_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "PO Number",
      dataIndex: "customer_PO_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.customer_PO_Number
              ? row.customer_PO_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "PO Number",
      dataIndex: "customer_PO_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "customer_PO_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.customer_PO_Number
              ? row.customer_PO_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Dispatch Quantity",
      dataIndex: "dispatch_Quantity",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Quantity"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.dispatch_Quantity
              ? row.dispatch_Quantity
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "BL/LR Number",
      dataIndex: "bL_LR_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.bL_LR_Number
              ? row.bL_LR_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Truck Number",
      dataIndex: "truck_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "truck_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.truck_Number
              ? row.truck_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Material Number",
      dataIndex: "material_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "material_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {

        return (
          <div>
            {row.material_Number
              ? row.material_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Material Name",
      dataIndex: "material_Name",
      sorter: true,
      showSorterTooltip: false,
      width: 240,
      sortOrder:
        tableSorting.sortColumn === "material_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            <label>
              {row.material_Name ? row.material_Name : "N/A"}
            </label>
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (_i, row) => (
        <div
          className="tbl_info_details"
          onClick={() => handleOverviewDetailsPage(row)}
        >
          <InfoCircleTwoTone />
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 900 }}
        className="logistic_tables"
        dataSource={tabTableData.logisticsCustomerDeliveryPendingTab}
        loading={isLoading}
        onChange={handleTableAscDes}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        pagination={{
          total: totalRecords,
          pageNo: pageNo,
          pageSize: 10,
          responsive: true,
          showSizeChanger: false,
          current: pageNo,
          onChange: (pageNum) => setPageNo(pageNum),
        }}
        columns={tableColumns}
        rowStyle={(record, index) => ({
          backgroundColor: index % 2 === 0 ? "red" : "#ffffff",
        })}
      />
    </Fragment>
  );
};

export default LogisticCustomerDelivery;
